import React, { useState, useEffect } from "react";
import SubAdminListPage from "../../entities/SubAdminPage/SubAdminList";
import AuthService from "../../api/AuthService";
import { useAlert } from "../../context/AlertContext";

const SubAdmin = () => {
  const [subAdmins, setSubAdmins] = useState([]);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [total, setTotal] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteTargetSubAdmin, setDeleteTargetSubAdmin] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const { showAlert } = useAlert();

  useEffect(() => {
    fetchSubAdmins();
  }, [page, rowsPerPage, searchText]);

  const fetchSubAdmins = async () => {
    try {
      setLoading(true);

      const response = await AuthService.getSubAdminList(
        page,
        rowsPerPage,
        searchText
      );

      if (response?.success && response?.data) {
        setSubAdmins(response.data.subadmins || []);

        setTotal(
          response.data.pagination?.total || 0
        );
      } else {
        showAlert("Failed to fetch sub admins", "error");
      }
    } catch (error) {
      showAlert(
        error?.response?.data?.message ||
        "Failed to fetch sub admins",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleSearchChange = (value) => {
    setSearchText(value);
    setPage(1); // Reset to first page on search
  };

  const handleDeleteSubAdmin = (subAdmin) => {
    setDeleteTargetSubAdmin(subAdmin);
    setDeleteModalOpen(true);
  };

  const handleCloseDeleteModal = () => {
    setDeleteModalOpen(false);
    setDeleteTargetSubAdmin(null);
  };

  const handleConfirmDelete = async () => {
    const subAdminId = deleteTargetSubAdmin?._id || deleteTargetSubAdmin?.id;
    if (!subAdminId) return;

    try {
      setDeleteLoading(true);
      await AuthService.deleteSubAdmin(subAdminId);
      showAlert("Sub Admin deleted successfully", "success");
      handleCloseDeleteModal();
      fetchSubAdmins(); // Refresh the list
    } catch (error) {
      console.error("Error deleting sub admin:", error);
      showAlert(
        error?.response?.data?.message || "Failed to delete sub admin",
        "error"
      );
    } finally {
      setDeleteLoading(false);
    }
  };

  return (
    <SubAdminListPage
      subAdmins={subAdmins}
      page={page}
      total={total}
      setPage={setPage}
      setRowsPerPage={setRowsPerPage}
      rowsPerPage={rowsPerPage}
      searchText={searchText}
      onSearchChange={handleSearchChange}
      loading={loading}
      deleteModalOpen={deleteModalOpen}
      deleteTargetSubAdmin={deleteTargetSubAdmin}
      onDeleteSubAdmin={handleDeleteSubAdmin}
      onCloseDeleteModal={handleCloseDeleteModal}
      onConfirmDeleteModal={handleConfirmDelete}
      deleteLoading={deleteLoading}
    />
  );
};

export default SubAdmin;
